'use client';

import { BoxCTA } from '@lichtblick/photon/atoms/box-cta/box-cta';
import type { FC } from 'react';

import type { TReferralType } from '../../types/storyblok';

export const PrivacyButton: FC<Pick<TReferralType, 'privacyButton'>> = ({ privacyButton }) =>
  privacyButton ? (
    <BoxCTA
      as="button"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        window.__ucCmp?.showSecondLayer();
      }}
      variant="neutral-filled"
    >
      {privacyButton}
    </BoxCTA>
  ) : null;
